// TYPES SHIPPER TRUCKS
export const SHIPPER_TRUCK_PIPE = "PIPA";
export const SHIPPER_TRUCK_TANKS = "TANQUE";

export const SHIPPER_TRUCK_STACIONARY = "ESTACIONARIO";
export const SHIPPER_TRUCK_PORTABLE = "PORTATIL";
// TYPES DOCUMENTS
export const SERVICE = "SERVICIO";
export const ORDER = "PEDIDO";
export const SERVICES = "SERVICIOS";
export const NOTES = "NOTES";
// TYPES STATUS
export const ACTIVE = "ACTIVE";
export const DONE = "DONE";
export const CANCELED = "CANCELED";
export const DISCONNECTED = "DISCONNECTED";
// TYPES PHONE
export const NO_PHONE = "SIN TELEFONO";
